import React from "react";
import Select from "react-select";

const CustomSelect = (props) => {
  const borderColor = props.invalid ? "red" : "#ddd";
  const customStyles = {
    control: (base, state) => ({
      ...base,
      "borderColor": borderColor,
      "&:hover": { borderColor: borderColor },
    }),
    option: (provided, state) => {
      const zIndex = 3;

      return { ...provided, zIndex };
    },
  };

  return <Select styles={customStyles} {...props} />;
};

export default CustomSelect;
